import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MyWardrobePage } from './my-wardrobe.page';

const routes: Routes = [
  {
    path: '',
    component: MyWardrobePage
  },
  {
    path: 'detail/:id',
    loadChildren: () => import('../product/product-detail/product-detail.module').then( m => m.ProductDetailPageModule)
  },
  {
    path: 'edit/:id',
    loadChildren: () => import('../product/edit-product/edit-product.module').then( m => m.EditProductPageModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MyWardrobePageRoutingModule {}
